import { ModelBase } from 'store/model-base';

export class NowDataUsageCollection extends ModelBase {
    public static storeName: string = 'nowDataUsageCollection';

    public heading: string;
    public planDataContent: string;
    public descriptiveContent: string;
    public dataUsageDetails: NowDataUsageDetails[];
    public noDataUsedContent?: string;
    public noDataUsedLanding?: string;

    public static create<T extends ModelBase>(initData: object): T {
        const usageData: NowDataUsageCollection = super.create<NowDataUsageCollection>(initData);
        
        return super.create<T>(usageData);    
    }
}

